import React from "react";
import { KTMScreen, ActionEvent, RenderEvent, renderScreen } from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import {
  Layout,
  Dialog,
  Button,
  Column,
  Panel,
  Display,
  Line,
  Card,
} from "ktm-ui";
import moment from "moment";
import ReactMoment from "react-moment";
import { CustomDropdown } from "components/CustomDropdown";
import toastr from "toastr";
import axios from "axios";
import CustomToolTip from "components/CustomToolTip";

interface IdsBenefit {
  Id: string;
  Policy_Id: string;
  Employee_Id: string;
  PolicyBenefit_Id: string;
  BenefitCategory_Id: string;
  Coverage: string;
  HasProrating: boolean;
  OverrideLimitsFlag: boolean;
  HSALimitOverride: number;
  LSALimitOverride: number;
  FlexLimitOverride: number;
  BenefitYear_Id: string;
  SalaryMoney: number;
}

interface IdsEmployee {
  Id: string;
  Name: string;
  HireDate: string;
  WaitingPeriodMonths: number;
  BenefitStartDate: string;
  IsStartDateAdjusted: boolean;
}

interface IdsBenefitYear {
  Id: string;
  StartDate: string;
}

export default KTMScreen(
  { name: "planadmin.employee-benefits.edit" },
  class extends React.Component<{
    employeeBenefit_id: string;
  }> {
    data: {
      dsBenefit: IdsBenefit;
      dsEmployee: IdsEmployee;
      dsBenefitYear: IdsBenefitYear;
    };

    state = {
      employeeStartDate: null,
      resetPAapprovedDate: false,
      showStartDateInput: false,
      showStartDateModal: false,
      isFlex: false,
      options: [],
      selectedOption: null,
      creditCalcMethod: null,
      isEligible: false,
    };

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsBenefit";
      await KTMApi.start(screen, {
        "@employeeBenefit_id": this.props.employeeBenefit_id,
      });
      screen.title = "Edit employee benefit limits";

      await this.getBenefitCategories();
      await screen.triggerAction(this.set_override_visibility);
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout>
          {draw(this.header)}
          {draw(this.main_tab)}
          {draw(this.footer)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
            return <Dialog.Header label={"general"} />;
    }

    footer({ field, draw, action }: RenderEvent) {
      var disableSave = this.data.dsBenefit.BenefitCategory_Id == null || 
                        this.data.dsBenefit.BenefitCategory_Id == undefined ||
                        this.state.isEligible == false;

      return (
        <Dialog.Footer>
          <Button
            action={action(this.submit)}
            label="Save"
            size="large"
            style="primary"
            disable={disableSave}
          />
        </Dialog.Footer>
      );
    }

    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>
            {draw(this.general)}
          </Column>
        </Panel>
      );
    }

    general({ field, draw, action }: RenderEvent) {
      var limits = <Line>No Limits to Display</Line>;
      if (field("@dsBenefit.Coverage").record.Coverage == "FAMILY") {
        limits = (
          <Line>
            <Display field={field("@dsPolicyBenefitLimits.HSAFamilyLimit")} />
            <Display field={field("@dsPolicyBenefitLimits.LSAFamilyLimit")} />
          </Line>
        );
      } else if (field("@dsBenefit.Coverage").record.Coverage == "SINGLE") {
        limits = (
          <Line>
            <Display field={field("@dsPolicyBenefitLimits.HSASingleLimit")} />
            <Display field={field("@dsPolicyBenefitLimits.LSASingleLimit")} />
          </Line>
        );
      } else if (field("@dsBenefit.Coverage").record.Coverage == "COUPLE") {
        limits = (
          <Line>
            <Display field={field("@dsPolicyBenefitLimits.HSACoupleLimit")} />
            <Display field={field("@dsPolicyBenefitLimits.LSACoupleLimit")} />
          </Line>
        );
      }
      return (
        <div>
        <Card>
          <Line>
              <div className="employee-edit-bencat" style={{width:"250px"}}>
                <div className="RT-TextBox edit-employee-ben-cat">
                  <label className="RT-Label">
                    <span className="text-danger">*</span>
                      Benefit Category
                      <CustomToolTip
                        header="Benefit Category"
                        bodyContent="Changes to Benefit Category update employee benefits immediately. Per policy, edits that would result in a decreased benefit limit mid-year are discouraged."
                      />
                  </label>
                  <CustomDropdown 
                    options={this.state.options.map((option) => {return option.name})} 
                    selectedOption={this.state.selectedOption.name} 
                    setSelectedOption={this.setSelectedOption} 
                  />
                </div>
              </div>
            <div className="RT-Line__item">
              <div className="RT-Static-Field">
                <label className="RT-Static-Field__label">Coverage </label>
                <div className="RT-Static-Field__content">
                  {this.data.dsBenefit.Coverage}
                </div>
              </div>
            </div>
            </Line>
          </Card>
          {this.state.creditCalcMethod === 'SALARY' ? draw(this.salaryInput) : null}
          <Card label="Limit">{limits}</Card>
        </div>
      );
    }

    salaryInput({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <Display field={field("SalaryMoney")} />
          </Line> 
        </Card>
      );
    }

    limit_overrides({ field, draw, action }: RenderEvent) {
      return (
        <Card label="Adjusting Entry">
          <Display field={field("OverrideLimitsFlag")} />
          <Line>
            <Display field={field("HSALimitOverride")} />
            <Display field={field("LSALimitOverride")} />
            <Display field={field("FlexLimitOverride")} />
          </Line>
        </Card>
      );
    }

    setSelectedOption = async (selectedOption: any) => {
      var findOption = this.state.options.find((option) => option.name == selectedOption);
      this.setState({ 
        selectedOption: findOption
      });
      this.data.dsBenefit.BenefitCategory_Id = findOption.id;
      await this.checkBenCatType();
    };

    async getBenefitCategories() {
      let response = await fetch("/api/Employees/getbenefitcategoriesforedit?policyId=" + this.data.dsBenefit.Policy_Id + "&currentBenCatId=" + this.data.dsBenefit.BenefitCategory_Id);
      let res = await response.json();
      var options = [{Id: null, name: "--Select--"}, ...res];
      var selectedOption = options.find((option) => option.id == this.data.dsBenefit.BenefitCategory_Id);
      this.setState({ 
        options: options,
        selectedOption: selectedOption
      });
      await this.checkBenCatType();
    }

    async checkBenCatType() {
      if (this.data.dsBenefit.BenefitCategory_Id == null || this.data.dsBenefit.BenefitCategory_Id == undefined){
        this.setState({
          isFlex: false,
          creditCalcMethod: null
        });
        return;
      }
      
      let response = await fetch("/api/Employees/checkbencattype?policyId=" + this.data.dsBenefit.Policy_Id+"&bencatId="+this.data.dsBenefit.BenefitCategory_Id+"&employeeId="+ this.data.dsBenefit.Employee_Id);
      let res = await response.json();
      if(res.success){
      this.setState({
          isFlex: res.benCat.isFlex,
          creditCalcMethod : res.benCat.creditCalcMethod,
          isEligible: true
      });
      } 
      else {
        toastr.error(res.message);
        this.setState({
          isFlex: false,
          creditCalcMethod: null,
          isEligible: false
        });
      }
    }

    async submit({ screen }: ActionEvent) {
      if(this.data.dsBenefit.SalaryMoney != null && this.data.dsBenefit.SalaryMoney != undefined){
        this.data.dsBenefit.SalaryMoney = Math.round(this.data.dsBenefit.SalaryMoney);
      }
      
      await KTMApi.action(screen, "submit", {
        "@dsBenefit.BenefitCategory_Id": this.data.dsBenefit.BenefitCategory_Id,
        "@dsBenefit.Coverage": this.data.dsBenefit.Coverage,
        "@dsBenefit.HasProrating": this.data.dsBenefit.HasProrating,
        "@dsBenefit.OverrideLimitsFlag": this.data.dsBenefit.OverrideLimitsFlag,
        "@dsBenefit.HSALimitOverride": this.data.dsBenefit.HSALimitOverride,
        "@dsBenefit.LSALimitOverride": this.data.dsBenefit.LSALimitOverride,
        "@dsBenefit.FlexLimitOverride": this.data.dsBenefit.FlexLimitOverride,
        "@employeeBenefit_id": this.props.employeeBenefit_id,
        "@dsEmployee.SalaryMoney": this.data.dsBenefit.SalaryMoney,
      });

      screen.close({ continue: true });
    }

    async set_override_visibility({ screen }: ActionEvent) {
      screen.hide("@dsBenefit.HSALimitOverride");
      screen.hide("@dsBenefit.LSALimitOverride");
      screen.hide("@dsBenefit.FlexLimitOverride");
      if (screen.getValue("@dsBenefit.OverrideLimitsFlag")) {
        screen.unhide("@dsBenefit.HSALimitOverride");
        screen.unhide("@dsBenefit.LSALimitOverride");
        screen.unhide("@dsBenefit.FlexLimitOverride");
      }
    }
  }
);
